import { Vocabulary } from '@prometheus/vocabulary';
import { Workspace } from '@prometheus/workspace';
import { Cohort } from '@prometheus/cohorts';
import { ConceptSet } from '@prometheus/concept-sets';
import { Study } from '@prometheus/study-manager';
import { Analyses } from '@prometheus/analyses';
import { Documents } from '@prometheus/documents';
import { Users } from '@prometheus/users';
import { DataCatalog } from '@prometheus/data-catalog';
import { Admin } from '@prometheus/admin';
import { CustomCode } from '@prometheus/custom-code';
import { Library } from '@prometheus/library';
import { ModuleConfig } from './interfaces';
import { FeatureAnalyses } from '@prometheus/feature-analyses';
import i18n from 'i18next';

export const modulesSideNavigation = (): ModuleConfig[] => [
  {
    title: i18n.t('main_menu.workspace', 'Workspace'),
    name: 'workspace',
    path: 'workspace',
    iconName: 'workspace',
    subModules: {
      cohort: Cohort,
      concept: ConceptSet,
      analyses: Analyses,
      datasources: DataCatalog,
      documents: Documents,
      vocabulary: Vocabulary,
      customCode: CustomCode,
      study: Study,
      featureanalyses: FeatureAnalyses,
    },
    isMainMenu: true,
    component: Workspace,
  },
  {
    title: i18n.t('main_menu.studies', 'Studies'),
    name: 'study',
    path: 'study-manager',
    iconName: 'study',
    subModules: {
      cohort: Cohort,
      concept: ConceptSet,
      analyses: Analyses,
      datasources: DataCatalog,
      documents: Documents,
      users: Users,
      vocabulary: Vocabulary,
      featureanalyses: FeatureAnalyses,
      study: Study,
      customCode: CustomCode,
    },
    isMainMenu: true,
    component: Study,
  },
  {
    title: i18n.t('main_menu.library', 'Artifacts'),
    name: 'library',
    path: 'library',
    iconName: 'library',
    subModules: {
      cohort: Cohort,
      concept: ConceptSet,
      vocabulary: Vocabulary,
      featureanalyses: FeatureAnalyses,
      library: Library,
      study: Study,
      users: Users,
      documents: Documents,
      customCode: CustomCode,
    },
    isMainMenu: true,
    component: Library,
  },
  // {
  //   title: 'Expert finder',
  //   name: 'users',
  //   path: 'users',
  //   iconName: 'users',
  //   subModules: { study: Study },
  //   isMainMenu: true,
  //   component: Users,
  // },
  {
    title: i18n.t('main_menu.catalog', 'Data Catalog'),
    name: 'datacatalog',
    path: 'data-catalog',
    iconName: 'dataCatalog',
    subModules: {
      cohort: Cohort,
      concept: ConceptSet,
      analyses: Analyses,
      datasources: DataCatalog,
      documents: Documents,
      users: Users,
      vocabulary: Vocabulary,
      study: Study,
    },
    isMainMenu: true,
    component: DataCatalog,
  },
  {
    title: i18n.t('home_page.documentation', 'Documentation'),
    name: 'documentation',
    path: 'documentation',
    iconName: 'documentation',
    subModules: {},
    isMainMenu: false,
    component: Documents,
  },
  {
    title: i18n.t('main_menu.vocabulary', 'Vocabulary'),
    name: 'vocabulary',
    path: 'vocabulary',
    iconName: 'vocabulary',
    isMainMenu: true,
    component: Vocabulary,
    subModules: {
      concept: ConceptSet,
      study: Study,
    },
  },
  {
    title: i18n.t('main_menu.settings', 'Settings'),
    name: 'admin',
    path: 'admin',
    iconName: 'admin',
    subModules: {
      datasources: DataCatalog,
      documents: Documents,
      users: Users,
      study: Study,
    },
    isMainMenu: true,
    component: Admin,
  },
];
